// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGEdit = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#edit__clip0_12_2836)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "edit__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#edit__clip1_12_2836)",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.377 2.571c.915 0 1.783.366 2.423 1.006l4.217 4.24c1.325 1.337 1.325 3.509 0 4.846L11.989 29.692c-.217.217-.503.33-.812.33l-.012.013h-7.45c-.63 0-1.143-.515-1.144-1.143V21.44c0-.309.126-.595.332-.812L19.954 3.577c.652-.652 1.509-1.006 2.423-1.006zM4.846 21.908v5.84h5.851l13.411-13.411-5.846-5.846L4.846 21.908zm17.52-17.04c-.308 0-.594.115-.811.332l-1.681 1.68 5.846 5.845 1.674-1.674c.446-.446.446-1.166 0-1.611L23.177 5.2c-.217-.217-.503-.332-.81-.332z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#edit__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "edit__clip0_12_2836",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "edit__clip1_12_2836",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGEdit.displayName = 'SVGEdit';
export default SVGEdit;